module.exports = __webpack_public_path__ + "img/9788954431088.3f249dd6.jpg";